module.exports = __webpack_public_path__ + "static/media/sid2022-img.565875b1.png";